/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_ManageInputs */

const th_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดการ`)
};

const en_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage`)
};

const ja_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const zh_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const es_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar`)
};

const pt_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar`)
};

const id_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola`)
};

const fr_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer`)
};

const tl_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamahalaan`)
};

const vi_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý`)
};

const ko_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관리`)
};

const de_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten`)
};

const ru_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управлять`)
};

const tr_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yönet`)
};

const it_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci`)
};

const pl_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj`)
};

const uk_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Керувати`)
};

const hi_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रबंधित करें`)
};

const ar_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة`)
};

const ms_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urus`)
};

const bn_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরিচালনা`)
};

const zh_tw2_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const zh_hk2_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const ur_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتظام`)
};

const fa_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدیریت`)
};

const sw_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simamia`)
};

const nl_event_manage = /** @type {(inputs: Event_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheren`)
};

/**
* | output |
* | --- |
* | "Manage" |
*
* @param {Event_ManageInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_manage = /** @type {((inputs?: Event_ManageInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_ManageInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_manage(inputs)
	if (locale === "ja") return ja_event_manage(inputs)
	if (locale === "zh") return zh_event_manage(inputs)
	if (locale === "es") return es_event_manage(inputs)
	if (locale === "pt") return pt_event_manage(inputs)
	if (locale === "id") return id_event_manage(inputs)
	if (locale === "fr") return fr_event_manage(inputs)
	if (locale === "tl") return tl_event_manage(inputs)
	if (locale === "vi") return vi_event_manage(inputs)
	if (locale === "ko") return ko_event_manage(inputs)
	if (locale === "de") return de_event_manage(inputs)
	if (locale === "ru") return ru_event_manage(inputs)
	if (locale === "tr") return tr_event_manage(inputs)
	if (locale === "it") return it_event_manage(inputs)
	if (locale === "pl") return pl_event_manage(inputs)
	if (locale === "uk") return uk_event_manage(inputs)
	if (locale === "hi") return hi_event_manage(inputs)
	if (locale === "ar") return ar_event_manage(inputs)
	if (locale === "ms") return ms_event_manage(inputs)
	if (locale === "bn") return bn_event_manage(inputs)
	if (locale === "zh-TW") return zh_tw2_event_manage(inputs)
	if (locale === "zh-HK") return zh_hk2_event_manage(inputs)
	if (locale === "ur") return ur_event_manage(inputs)
	if (locale === "fa") return fa_event_manage(inputs)
	if (locale === "sw") return sw_event_manage(inputs)
	if (locale === "nl") return nl_event_manage(inputs)
	return en_event_manage(inputs)
});